/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */

import React, { useEffect, useState } from 'react'

import { Link } from 'react-router-dom'

const themeLogo = (theme: string) => (theme.includes('dark') ? '/logo-dark.png' : '/logo-light.png')

const currentTheme = () => document.documentElement.getAttribute('data-theme') || 'cooltrax-light'

/**
 * The Cooltrax logo at the top of the nav, linking home. It follows the `data-theme` on
 * `<html>`; `compact` swaps in the square mark for the icons-only sidebar.
 */
export const NavLogo: React.FC<{ compact?: boolean }> = ({ compact = false }) => {
  const [theme, setTheme] = useState(currentTheme)

  useEffect(() => {
    const themeObserver = new MutationObserver(() => setTheme(currentTheme()))
    themeObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] })
    return () => themeObserver.disconnect()
  }, [])

  return (
    <Link to="/" className="flex items-center min-w-0">
      {compact ? (
        <img className="h-8 w-8" src="/favicon.ico" alt="Cooltrax" />
      ) : (
        <img className="h-9 w-auto max-w-full" src={themeLogo(theme)} alt="Cooltrax" />
      )}
    </Link>
  )
}
